// 検索条件のプリセット種別
export enum SearchConditionPresetKinds {
  Person = 1,
  Department = 2,
  All = 3,
}
